import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function SelectControlOption({
  highlighted,
  selected,
  className,
  highlightedClassName,
  selectedClassName,
  style,
  onMouseEnter,
  onClick,
  innerRef,
  children,
}) {
  return (
    <button
      className={clsx(
        'flex items-center cursor-pointer w-full focus:outline-none',
        highlighted && highlightedClassName,
        selected && selectedClassName,
        className,
      )}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      style={style}
      ref={innerRef}
      type="button"
    >
      {children}
    </button>
  );
}

SelectControlOption.defaultProps = {
  highlighted: false,
  selected: false,
  className: null,
  highlightedClassName: null,
  selectedClassName: null,
  style: {},
  onMouseEnter: () => {},
  onClick: () => {},
};

SelectControlOption.propTypes = {
  highlighted: PropTypes.bool,
  selected: PropTypes.bool,
  className: PropTypes.string,
  highlightedClassName: PropTypes.string,
  selectedClassName: PropTypes.string,
  style: PropTypes.object,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

const SelectControlOptionForwardRef = forwardRef((props, ref) => (
  <SelectControlOption {...props} innerRef={ref} />
));

SelectControlOptionForwardRef.displayName = 'SelectControlOptionForwardRef';

export default SelectControlOptionForwardRef;
